import * as Sentry from "@sentry/react";

const dsn = window.config.SENTRY_DSN;
const environment = window.config.ENV;

export function initSentry(): void {
    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        environment,
        tracesSampleRate: 1.0,
        // Ignore common non-actionable errors
        ignoreErrors: [
            "ResizeObserver loop limit exceeded",
            "Non-Error promise rejection captured",
        ],
    });
}
